'use client';

import type { FC } from 'react';

import { ShimmeringBlurOverlay } from '@packages/shared/src/components/ShimmeringBlurOverlay/ShimmeringBlurOverlay';
import { useConfig } from '@packages/shared/src/hooks/useConfig/useConfig';
import { useLocalizedPageUrl } from '@packages/shared/src/providers/LocalizedPageUrlProvider/useLocalizedPageUrl';
import { usePageTransition } from '@packages/shared/src/providers/PageTransitionProvider/usePageTransition';

export type ProductListBlurOverlayProps = {
  topLevelCategories?: string[];
};

export const ProductListBlurOverlay: FC<ProductListBlurOverlayProps> = ({ topLevelCategories }) => {
  const {
    i18n: { languages, defaultLocale },
  } = useConfig();

  const nonDefaultLanguages = languages.filter((language) => !defaultLocale.startsWith(language));
  const productListPrefixes = nonDefaultLanguages
    .map((language) => `/${language}/s/`)
    .concat(['/s/'])
    .concat(topLevelCategories?.map((route) => `/${route}`) ?? []);

  const loading = usePageTransition();
  const url = useLocalizedPageUrl();

  const isRelevantTransition =
    loading && productListPrefixes.some((prefix) => url?.startsWith(prefix));

  return <ShimmeringBlurOverlay show={isRelevantTransition} />;
};
